<div *ngIf="show" class="layout-mask modal-in flex justify-content-center align-items-center">
  <div class="lds-ellipsis">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
